import { component } from 'picoapp'
import { get } from '../lib/ajax'
import { resizeImageSrc } from '../lib/utils'
import $ from 'quantdom'

export default component((node) => {
  const url = $(node).attr('data-url')
  const productId = $(node).attr('data-product-id')

  get(url + `&product_id=${productId}`).then((res) => {
    const img = res.products[0].featured_image
    $(node).find('[data-upsell-image]').attr('src', resizeImageSrc(img, 500))
    $(node).find('[data-upsell-title]').text(res.products[0].title)
  })
})
